import { render, staticRenderFns } from "./CoreUIIcons.vue?vue&type=template&id=63ab39b0"
import script from "./CoreUIIcons.vue?vue&type=script&lang=js"
export * from "./CoreUIIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports